import React from "react";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../../components/Common/ChartsDynamicColor";

const RadialChart = ({ dataColors }) => {
  const radialChartColors = getChartColorsArray(dataColors);

  const series = [46, 54];
  const options = {
    plotOptions: {
      radialBar: {
        dataLabels: {
          name: {
            fontSize: "22px",
          },
          value: {
            fontSize: "16px",
          },
          total: {
            show: true,
            label: "Total",
            formatter: function (w) {
              return 1480;
            },
          },
        },
      },
    },

    labels: ["New cars", "Used cars"],
    colors: radialChartColors,
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="radialBar"
      height="390"
      className="apex-charts"
    />
  );
};

export default RadialChart;
